<template>
  <div>
    <recipient-layout v-if="user?.type === 'recipient'">
      <router-view />
    </recipient-layout>
    <template v-else>
      <v-app
        v-if="
          user &&
          !['auth-login', 'auth-forgot-password', 'auth-reset-password'].includes(
            $route.name
          )
        "
      >
        <app-navigation-drawer
          v-if="customMenu.length > 0"
          :drawer="drawer"
          :menu="['company', 'customer'].includes(user.type) ? menu : customMenu"
          :available-languages="availableLanguages"
          @update:drawer="drawer = $event"
          @set-lang="setLang"
          @logout="logout"
        />
        <app-bar
          v-if="$route.name !== 'canteen'"
          :menu="menu"
          flat
          :available-languages="availableLanguages"
          :hide-button="customMenu.length === 0"
          @toggle-drawer="drawer = !drawer"
          @set-lang="setLang"
          @logout="logout"
        />

        <global-snackbar></global-snackbar>
        <v-main :style="$route.name === 'company-menu' && 'background-color: #fff'">
          <v-container fluid class="pa-0">
            <v-row
              :no-gutters="device.isDesktop || !isCanteen"
              :class="isCanteen ? '' : device.isDesktop ? 'pa-0' : ''"
            >
              <v-col cols="12">
                <router-view></router-view>
              </v-col>
            </v-row>
          </v-container>
          <v-btn
            v-if="!isCanteen && fab"
            fab
            color="primary"
            dark
            bottom
            right
            fixed
            @click="toTop"
          >
            <v-icon>mdi-chevron-up</v-icon>
          </v-btn>
        </v-main>
        <app-footer v-if="!isCanteen" />
      </v-app>
      <v-app v-else>
        <router-view></router-view>
      </v-app>
    </template>
    <!--PORUDZBA-->
    <order-notification-snackbar />
  </div>
</template>

<script>
import setLang from "@/mixins/setLang";
import menuItemsMixin from "@/mixins/menuItemsMixin";
import menuMixin from "@/mixins/menuMixin";
import GlobalSnackbar from "@/components/global/GlobalSnackbar.vue";
import RecipientLayout from "@/layouts/RecipientLayout.vue";
import AppFooter from "@/components/layout/AppFooter.vue";
import OrderNotificationSnackbar from "@/components/layout/OrderNotificationSnackbar.vue";
import AppNavigationDrawer from "@/components/layout/AppNavigationDrawer.vue";
import LanguageSelector from "@/components/layout/LanguageSelector.vue";
import AppAvatarMenu from "@/components/layout/AppAvatarMenu.vue";
import AppReportGuestAvatarMenu from "@/components/layout/AppReportGuestAvatarMenu.vue";
import AppLogo from "@/components/layout/AppLogo.vue";
import SitesDropdown from "@/components/layout/SitesDropdown.vue";
import AppBar from "@/components/layout/AppBar.vue";

export default {
  mixins: [setLang, menuItemsMixin, menuMixin],
  components: {
    GlobalSnackbar,
    RecipientLayout,
    AppFooter,
    OrderNotificationSnackbar,
    AppNavigationDrawer,
    LanguageSelector,
    AppAvatarMenu,
    AppReportGuestAvatarMenu,
    AppLogo,
    SitesDropdown,
    AppBar,
  },
  data: () => ({
    fab: false,
    drawer: false,
  }),
  created() {
    this.$root.$on("change-credit-emit", (data) => {
      if (data) {
        const userCredit = this.user?.credit || [];
        const substraction = data === "add" ? -1 : 1;
        if (userCredit.length && userCredit[userCredit.length - 1].duguje) {
          userCredit[userCredit.length - 1].duguje =
            parseFloat(userCredit[userCredit.length - 1].duguje) + substraction;
        }

        this.$forceUpdate();
      }
    });

    this.$root.$on("langChanged", ({ data }) => {
      let lang = data.data.alphabet;
      if (lang == "cir") {
        this.$store.commit("SAVE_LANGUAGE", 1 - 1);
      } else if (lang == "lat") {
        this.$store.commit("SAVE_LANGUAGE", 1 - 0);
      }
    });
  },
  mounted() {
    this.$store.commit("SET_DRAWER", true);
    this.getLang();
    this.setupScrollListener();
  },

  beforeDestroy() {
    this.removeScrollListener();
  },

  methods: {
    setupScrollListener() {
      this.handleScroll = () => {
        this.fab = window.scrollY > 200;
      };
      window.addEventListener("scroll", this.handleScroll);
    },

    removeScrollListener() {
      if (this.handleScroll) {
        window.removeEventListener("scroll", this.handleScroll);
      }
    },

    logout() {
      this.$store.dispatch("user/LOGOUT");
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
  computed: {
    isCanteen() {
      return ["canteen", "naplata2"].includes(this.$route.name);
    },
    site() {
      return this.$store.state.selectedRestaurant;
    },
    user() {
      return this.$store.state.user.user;
    },
    availableLanguages() {
      const settingsLanguages =
        this.company?.restaurant?.settings?.language ||
        this.restaurant?.settings?.language;

      const allLanguages = this.getAvailableLanguages();

      return settingsLanguages
        ? allLanguages.filter((lang) => settingsLanguages.includes(lang.code))
        : allLanguages;
    },
    company() {
      return this.$store.state.company;
    },
    restaurant() {
      return this.$store.state.restaurant;
    },
  },
  watch: {
    availableLanguages: {
      handler(newLanguages) {
        if (newLanguages.length > 0) {
          const locale =
            this.company?.restaurant?.settings?.language?.[0] ||
            this.restaurant?.settings?.language?.[0] ||
            newLanguages[0].code;
          this.$i18n.locale = locale;
        }
      },
      immediate: true,
    },
    "$store.state.user.user"() {
      if (!this.$store.state.user.user?.id) {
        this.$router.push({ name: "auth-login" }).then(() => {
          window.location.reload();
        });
      }
    },
    restaurant() {
      // Check if we need to redirect to home for restaurants
      const customersRestaurantIndex = this.computedItems.findIndex(
        (item) => item.title === "Корисници изабраног ресторана"
      );

      if (customersRestaurantIndex > -1) {
        this.$router.push({ name: "company-menu" });
      }
    },
  },
};
</script>

<style>
/* Global font family override */
* {
  font-family: "IBM Plex Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif !important;
}

.v-application {
  font-family: "IBM Plex Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif !important;
}

.v-application .text-h1,
.v-application .text-h2,
.v-application .text-h3,
.v-application .text-h4,
.v-application .text-h5,
.v-application .text-h6,
.v-application .headline,
.v-application .title,
.v-application .subtitle-1,
.v-application .subtitle-2,
.v-application .body-1,
.v-application .body-2,
.v-application .caption,
.v-application .overline,
.v-btn,
.v-card,
.v-list,
.v-toolbar,
.v-navigation-drawer {
  font-family: "IBM Plex Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif !important;
}
</style>
